<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <div class="bd-example">
            <dl class="row">
              <dt class="col-sm-3">{{ $tc('title.procedures', 0) }}</dt>
              <dd class="col-sm-9">{{procedureModel.procedureLabel}}</dd>
              <dt class="col-sm-3">{{ $tc('title.models', 1) }}</dt>
              <dd class="col-sm-9">{{procedureModel.modelCode}}</dd>
              <dt class="col-sm-3">{{ $t('page.generic.description') + ' ' + $tc('title.models', 1)}}</dt>
              <dd class="col-sm-9">{{ procedureModel.modelDescription }}</dd>
            </dl>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <router-link v-if="procedureModel.id" class="btn btn-primary float-right" role="button"
                           :to="{name: 'procedureModelEditRoute', params: {id:procedureModel.id}}">
                {{ $t('actions.edit') }}
              </router-link>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import miniToastr from 'mini-toastr' //ES6
import PageTitle from '@/components/PageTitle'
import ProcedureModelService from "@/services/ProcedureModelService";

const procedureModelService = ProcedureModelService.build();

export default {
  name: 'ProcedureModelShow',
  props: {
    id: {
      required: true
    }
  },
  components: {
    PageTitle,
  },
  data() {
    return {
      procedureModel: {}
    }
  },
  created() {
    miniToastr.init(); // config can be passed here miniToastr.init(config)
    miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.procedureModel = await procedureModelService.read(this.id)
    }
  }
}
</script>
